import React from "react";
import {
  ICommandBarCustomPlugin,
  IDataTableProps,
  RenderType,
} from "../../../../components/Table/interfaces/IDataTableProps";
import { IPackageViewProps } from "./interfaces/IPackageView";
import { Box } from "@mui/material";
import {
  AspectRatio,
  Cancel,
  Check,
  PendingActions,
} from "@mui/icons-material";
import { DataTable } from "../../../../components/Table/DataTable";
import { ContextMenu } from "../../../../components/ContextMenu/ContextMenu";
import { ViewCustomerConnection } from "../../../../components/CustomerTrackTable/components/ViewCustomerConnection/ViewCustomerConnection";
import { GetVehicle } from "../ComplaintLog/AddVehicle/GetVehicle";
import { CustomChip } from "../../../../components/CustomChip";
import { IPackageDetails } from "../../../../components/CustomerTrackTable/components/PackageDetails/IPackageDetails";
import { PackageDetails } from "../../../../components/CustomerTrackTable/components/PackageDetails/PackageDetails";
import { PartnerDetails } from "../../../../components/CustomerTrackTable/components/PartnersDetails/PartnerDetails";
import { ComplaintHistory } from "../../../../components/CustomerTrackTable/components/ComplaintHistory/ComplaintHistory";
// import { GetFamilyVehicle } from "./GetfamilyVehicle";

export const PackageView: React.FC<IPackageViewProps> = (props) => {
  const { memberShips } = props;

  const [openView, setOpenView] =
    React.useState<ICommandBarCustomPlugin | null>(null);
  const [packageDetails, setPackageDetails] =
    React.useState<IPackageDetails | null>(null);
  const [partnerDetails, setpartnerDetails] =
    React.useState<IPackageDetails | null>(null);
  const current_date = new Date();
  const [complaintHistory, setComplaintHistory] = React.useState(false);

  const [selectedMembershipCode, setSelectedMembershipCode] =
    React.useState(null);

  const handlePackageDetailsClick = (row: any) => {
    console.log("Clicked row:", row);
    if (row.membership_code) {
      setPackageDetails(row);
    } else {
      console.warn("No membership_code found for row:", row);
    }
  };

  const handleComplaintHistoryClick = (row: any) => {
    if (row.membership_code) {
      setSelectedMembershipCode(row.membership_code);
      setComplaintHistory(true);
    } else {
      console.warn("No membership_code found for row:", row);
    }
  };

  const handlePartnerCLick = (row: any) => {
    if (row.membership_code) {
      setSelectedMembershipCode(row.membership_code);
      setpartnerDetails(row);
    } else {
      console.warn("No membership_code found for row:", row);
    }
  };

  const tableData: IDataTableProps = {
    isDataLoading: false,

    columns: [
      {
        key: "actions",
        headerName: "Actions",
        fieldName: "",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row) => {
          return (
            <Box>
              <CustomChip
                color="primary"
                content={"See Details"}
                size="small"
                onClick={() => setOpenView(row)}
                sx={{ cursor: "pointer", fontSize: "14px" }}
              />
              <CustomChip
                color="success"
                content={"Package Details"}
                size="small"
                sx={{ ml: "10px", cursor: "pointer", fontSize: "14px" }}
                onClick={() => handlePackageDetailsClick(row)}
              />
              {row.partner_id > 2 && (
                <CustomChip
                  color="error"
                  content={"Partner Details"}
                  size="small"
                  sx={{ ml: "10px", cursor: "pointer", fontSize: "14px" }}
                  onClick={() => handlePartnerCLick(row)}
                />
              )}
              <CustomChip
                color="secondary"
                content={"Service History"}
                size="small"
                sx={{ ml: "10px", cursor: "pointer", fontSize: "14px" }}
                onClick={() => handleComplaintHistoryClick(row)}
              />
            </Box>
          );
        },
      },
      {
        key: "user_name",
        headerName: "User Name",
        fieldName: "user_name",
        renderType: RenderType.TEXT,
      },
      {
        key: "membership_id",
        headerName: "MemberShip Code",
        fieldName: "membership_code",
        renderType: RenderType.TEXT,
      },
      {
        key: "vehicle_number",
        headerName: "Vechicle Number",
        fieldName: "vehicle_number",
        renderType: RenderType.TEXT,
      },
      {
        key: "maker_name",
        headerName: "Brand",
        fieldName: "maker_name",
        renderType: RenderType.TEXT,
      },

      {
        key: "model_name",
        headerName: "Model",
        fieldName: "model_name",
        renderType: RenderType.TEXT,
      },
      {
        key: "contact_number",
        headerName: "Contact Number",
        fieldName: "contact_number",
        renderType: RenderType.TEXT,
      },
      {
        key: "remain_services",
        headerName: "Remain Services",
        fieldName: "remain_services",
        renderType: RenderType.TEXT,
      },

      {
        key: "membership_start_date",
        headerName: "Start Date",
        fieldName: "membership_start_date",
        renderType: RenderType.DATE,
      },
      {
        key: "membership_expiry_date",
        headerName: "Expiry Date",
        fieldName: "membership_expiry_date",
        renderType: RenderType.DATE,
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row) => {
          const expiryDate = new Date(row.membership_expiry_date);
          const isActive = expiryDate > current_date;

          return (
            <Box>
              {isActive ? (
                <Check color="success" />
              ) : (
                <Cancel color="warning" />
              )}
            </Box>
          );
        },
      },

      // {
      //   key: "actions",
      //   headerName: "Actions",
      //   fieldName: "",
      //   renderType: RenderType.CUSTOM_RENDER,
      //   onRowCellRender: (value, row) => {
      //     if ((row.package_id === 21) ||(row.package_id === 22) ||((row.package_id === 23) )  ) {
      //       setSelectedMembershipCode(row.membership_code);
      //       return (
      //         <ContextMenu
      //           menuOptions={[
      //             {
      //               icon: <AspectRatio />,
      //               label: "Add Vehicle",
      //               onClick: () => setOpenView(row),
      //             },
      //           ]}
      //         ></ContextMenu>
      //       );
      //     } else {
      //       return null;
      //     }
      //   },
      // },
    ],
    items: memberShips,
  };

  return (
    <>
      <DataTable {...tableData} />
      {/* {openView && (
        <GetFamilyVehicle
          open={true}
          connection={openView}
          memberID = {selectedMembershipCode}
          onClose={() => setOpenView(null)}
        />
      )} */}
      {openView && (
        <ViewCustomerConnection
          open={!!openView}
          connection={openView}
          onClose={() => setOpenView(null)}
        />
      )}
      {packageDetails && (
        <PackageDetails
          open={!!packageDetails}
          connection={packageDetails}
          onClose={() => setPackageDetails(null)}
        />
      )}

      {partnerDetails && (
        <PartnerDetails
          open={!!partnerDetails}
          connection={partnerDetails}
          onClose={() => setpartnerDetails(null)}
        />
      )}

      {complaintHistory && selectedMembershipCode && (
        <ComplaintHistory
          open={complaintHistory}
          onClose={() => setComplaintHistory(false)}
          memberDetails={selectedMembershipCode} // Pass the membership code here
        />
      )}
    </>
  );
};
